import { Space, Tag } from 'antd';
import { RiskAction } from '../../models';

export function RiskActionStatus(props: { riskAction?: RiskAction }) {
  let color: string = 'blue';
  let status = 'Devam ediyor';

  if (props.riskAction?.status === 'EVALUATING') {
    color = 'orange';
    status = 'Değerlendiriliyor';
  } else if (props.riskAction?.status === 'ACCEPTED') {
    color = 'green';
    status = 'Tamamlandı';
  } else if (props.riskAction?.status === 'REJECTED') {
    color = 'red';
    status = 'Reddedildi';
  }

  if (!props.riskAction) {
    return null;
  }

  return (
    <Space>
      <Tag color={color}>{status}</Tag>
    </Space>
  );
}
